module.exports = __webpack_public_path__ + "static/media/empty-categories.a61dccf7.svg";